import script from "./InvestimentosCompartilhadosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestimentosCompartilhadosPage.vue?vue&type=script&setup=true&lang=js"

import "./InvestimentosCompartilhadosPage.vue?vue&type=style&index=0&id=f844c878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f844c878"]])

export default __exports__